import { useMemo } from "react";
import { classNames } from "primereact/utils";
import styles from "./DesignStudioSwatches.module.scss";
import { IDesignStudioColors } from "../models/designStudioPresetModel";
import { buildDesignStudioPreviewStyle } from "../utils/designStudioPreviewUtility";

interface IDesignStudioSwatchesProps {
  colors: IDesignStudioColors;
  /** Small overlapping dots, for tight spots like a preset card's title row. */
  compact?: boolean;
  className?: string;
}

/** The palette at a glance: background pair, button, accent. */
export const DesignStudioSwatches = ({
  colors,
  compact = false,
  className,
}: IDesignStudioSwatchesProps) => {
  const style = useMemo(() => buildDesignStudioPreviewStyle(colors), [colors]);

  return (
    <span
      className={classNames(styles.root, { [styles.root_compact]: compact }, className)}
      style={style}
      aria-hidden
    >
      <span className={classNames(styles.swatch, styles.swatch_background)} />
      <span className={classNames(styles.swatch, styles.swatch_button)}>
        {!compact && "Aa"}
      </span>
      <span className={classNames(styles.swatch, styles.swatch_accent)} />
    </span>
  );
};
